interface ShortLongCompliance {
  amountInvested: number
  maxLimitPct: number
  maxMoneyLimit: number
  rating: string
  tradesCount: number
  amountAvailable: number
  investmentSharePct: number
  isCompliant: boolean
  breakReason: string
}

export interface IssuerCompliance {
  bankingGroupId: number
  code: string
  name: string
  amountInvested: number
  investmentSharePct: number
  isCompliant: boolean
  tradesCount: number
  long: ShortLongCompliance
  short: ShortLongCompliance
}

export interface IssuerCompliancesProps {
  longTermComplianceOnly: boolean
  isCompliant: boolean
  capitalBasis: number
  amountInvested: number
  tradesCount: number
  list: IssuerCompliance[]
}

export const transformIssuerCompliancesToTableItems = (issuerCompliances: IssuerCompliancesProps): IssuerCompliance[] =>
  issuerCompliances.list
